<template>
    <!-- Небольшой блок данных о юзере для вставки в таблицы и др. -->
    <div 
        v-if="userViewComputed" 
        class="gz-staff__info-block gz-staff__info-block_staff">
        <div class="gz-staff__info-block__avatar">
            <span v-if="userViewComputed.role.indexOf('PECHNIK') > -1" class="icon-hipster"></span>
            <span v-if="userViewComputed.role.indexOf('ADMIN') > -1" class="icon-user1"></span>
        </div>
        <div class="gz-staff__info-block__info">
            <div 
                v-if="userViewComputed.lname" :class="{'gz-staff__info-block__personal': isAdmin}" 
                @click="goTo()"
            >
                <span><nobr>{{ userViewComputed.lname }}</nobr></span>
                <span>&nbsp;<nobr>{{ userViewComputed.fname }}</nobr></span>
                <span v-if="userViewComputed.pname">&nbsp;<nobr>{{ userViewComputed.pname }}</nobr></span>
            </div>
            <div class="gz-staff__info-block__role">
                <span v-if="userViewComputed.role.indexOf('PECHNIK') > -1">печник</span>
                <span v-if="userViewComputed.role.indexOf('ADMIN') > -1">администратор</span>
            </div>
        </div>
    </div>   
</template> 

<script>
export default {
    name: 'StaffInfoBlock',

    props: {
        uid: {
            type: String
        }
    },
    data() {
        return {
            userView: {}
        }
    },
    computed: {
        uidComputed() {
            return this.uid
        },
        userViewComputed() {
            return this.userView.attributes
        }
    },
    mounted() {
        this.$store.dispatch('staffUserviewGet', this.uidComputed)
            .then(() => {
                this.userView = this.$store.getters['staffUserview']
            })
    },
    methods: {
        goTo() {
            window.open(`/admin/staff/${this.userViewComputed.profid}`)
        }
    }
}
</script>